import script from "./BaseSignaturePad.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSignaturePad.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSignaturePad.vue?vue&type=style&index=0&id=d7965a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7965a46"]])

export default __exports__